<div class="step-container">
    <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="step-nav-bar">
        <a id="indicatorRules" routerLinkActive="active" [routerLink]="['indicator-rules']" [queryParams]="{getMultiFields: false}" [routerLinkActiveOptions]="{ exact: false }" queryParamsHandling="merge" mat-tab-link>Indicator Rules</a>
        <a id="multipleEntries" routerLinkActive="active" [routerLink]="['multiple-entries']" [queryParams]="{getMultiFields: true}" [routerLinkActiveOptions]="{ exact: false }" queryParamsHandling="merge" mat-tab-link>Multiple Entries</a>
    </nav>
    <mat-tab-nav-panel #tabPanel>
        <div class="step-sub-view">
            <router-outlet></router-outlet>
        </div>
    </mat-tab-nav-panel>
</div>